var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn-center btn-cu btn-l btn-fw btn-color-estandar",attrs:{"aria-disabled":_vm.isLoaded,"href":_vm.urlSignIn}},[_c('span',{staticClass:"cl-claveunica",style:(_vm.iconStyle)}),_c('span',{staticClass:"texto"},[_vm._v("Iniciar sesión")])])
}
var staticRenderFns = []

export { render, staticRenderFns }